import { combineReducers } from 'redux';
import common from 'ui-react-common';

import { stateReducers as application } from '../../pages/application-page/redux';
import { stateReducers as authentication } from '../authentication';
import { stateReducers as disclosures } from '../disclosures';
import { stateReducers as registration } from '../../pages/registration-page/redux';
import { stateReducers as adverseActionPage } from '../../pages/adverse-action-page/redux';
import { stateReducers as creditFreeze } from '../../pages/credit-freeze-page/redux';
import { stateReducers as piiRetry } from '../../pages/pii-retry-page/redux';
import { stateReducers as leadRegisterPage } from '../../pages/lead-register-page/redux';
import { stateReducers as leadCompletePage } from '../../pages/lead-complete-page/redux';
import { stateReducers as emailInUsePage } from '../../pages/email-in-use-page/redux';
// inject-yeoman-reducers-import: leave this comment here, it is used by the Yeoman generator

const offersPage = common.ui.components.redux.stateReducers;
const customizeOffers = common.ui.components.redux.customizeOffers.stateReducers;
const offer = common.ui.components.redux.offer.stateReducers;

const {
    routingSubscriberReducer: routerSubscriber,
} = common.ui.containers.routingSubscriber;
const { RlabReducer: rlab } = common.ui.components.rlab;
const global = common.globals.methods.reducer;

const rootReducer = combineReducers({
    global,
    application,
    authentication,
    disclosures,
    offersPage,
    offer,
    customizeOffers,
    registration,
    adverseActionPage,
    creditFreeze,
    piiRetry,
    routerSubscriber,
    leadRegisterPage,
    leadCompletePage,
    emailInUsePage,
    rlab
    // inject-yeoman-reducers-combine: leave this comment here, it is used by the Yeoman generator
});

export default rootReducer;
